import { render, staticRenderFns } from "./CustomerAddressForm.vue?vue&type=template&id=a6d3e9d0&"
import script from "./CustomerAddressForm.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports